import React, {Dispatch, SetStateAction, useState, useEffect, useRef} from 'react';
import Calendar from 'react-calendar';
import './MyCalendar.css';
import s from './MyCalendar.module.css';
import {format} from 'date-fns';
import {uk} from 'date-fns/locale';
import {Value} from './Calendar';
import {FormikSetFieldValue} from '../../types/CommonTypes';
import {dateFormatter} from '../../assets/utils/dateUtils';

type Props = {
	close: (b: boolean) => void;
	setCurrentDayName: (value: string) => void;
	setFieldValue: FormikSetFieldValue;
	fieldName: string;
	setValueDate?: Dispatch<SetStateAction<string>>;
};
const FilterDayCalendar: React.FC<Props> = ({
	close,
	setFieldValue,
	fieldName,
	setCurrentDayName,
	setValueDate,
}) => {
	const [value, onChangeValue] = useState<Value>(new Date());
	const calendarRef = useRef<HTMLDivElement>(null);
	const [isMobile, setIsMobile] = useState(false);

	useEffect(() => {
		const checkMobile = () => {
			setIsMobile(window.innerWidth <= 767.98);
		};
		
		checkMobile();
		window.addEventListener('resize', checkMobile);
		
		return () => window.removeEventListener('resize', checkMobile);
	}, []);

	// Функция для определения доступных дат
	const tileDisabled = ({ date, view }: { date: Date; view: string }) => {
		if (view !== 'month') return false;
		
		const today = new Date();
		const currentMonth = today.getMonth();
		const currentYear = today.getFullYear();
		const currentDay = today.getDate();
		
		const tileMonth = date.getMonth();
		const tileYear = date.getFullYear();
		const tileDay = date.getDate();
		
		// Если текущая дата - это 1, 2 или 3 число месяца
		if (currentDay <= 3) {
			// Разрешаем выбор дат текущего месяца
			if (tileYear === currentYear && tileMonth === currentMonth) {
				return false;
			}
			
			// Разрешаем выбор последнего дня предыдущего месяца
			const lastDayOfPrevMonth = new Date(currentYear, currentMonth, 0).getDate();
			const prevMonth = currentMonth === 0 ? 11 : currentMonth - 1;
			const prevYear = currentMonth === 0 ? currentYear - 1 : currentYear;
			
			if (tileYear === prevYear && tileMonth === prevMonth && tileDay === lastDayOfPrevMonth) {
				return false;
			}
			
			return true; // Блокируем все остальные даты
		}
		
		// В остальные дни разрешаем выбор только дат текущего месяца
		return !(tileYear === currentYear && tileMonth === currentMonth);
	};

	const handleChange = (newValue: any) => {
		const formatedDate = dateFormatter(newValue);
		setCurrentDayName(formatedDate);
		setFieldValue(fieldName, formatedDate);
		setValueDate && setValueDate(formatedDate);
		onChangeValue(newValue);
		close(false);
	};
	const formatMonthYear = (date: any) => {
		return format(date, 'LLLL yyyy', {locale: uk});
	};

	useEffect(() => {
		if (isMobile && calendarRef.current) {
			// Прокручиваем к календарю при открытии на мобильных
			calendarRef.current.scrollIntoView({behavior: 'smooth', block: 'center'});
		}
	}, [isMobile]);

	return (
		<>
			{isMobile && <div className={s.calendarOverlay} onClick={() => close(false)} />}
			<div className={s.dayCalendarContainer} ref={calendarRef}>
				<div className={s.calendarWrapper}>
					<Calendar
						view={'month'}
						tileClassName={s.calendarTile}
						locale="uk-UA"
						formatMonthYear={(locale, date) => formatMonthYear(date)}
						className={s.calendarContainer}
						onClickMonth={handleChange}
						onChange={handleChange}
						value={value}
						tileDisabled={tileDisabled}
					/>
				</div>
			</div>
		</>
	);
};

export default FilterDayCalendar;
